import "./publication.scss";
import "../../assets/scripts/isotope_init.js";
import $ from 'jquery';

// ISOTOPE
var $grid_publication = $('.grid_publication');
var itemSelector = '.publication';
var $checked;
var $pagerOnePage = document.getElementsByClassName("pager");
var $filterCount = $('.count-filter');
var qsRegexMotCle;
var qsRegexNom;
var qsRegexCategorie;
var qsRegexAnnee;

//Petit délai pour ne pas filtrer à la milliseconde près (On se laisse un instant pour ecrire avant de filtrer)
var debounce = function (func, wait, immediate) {

    var timeout;
    return function() {

        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);


    };
}


function checkFilter(){

}

//filtre de la grille de publication






// *************************************************************************************************************************************
// PAGINATION ISOTOPE

var lastPage = 0;
var currentNumberPages = 1;
var $pageSouhaitee = 1;
var currentPage = 1;
var currentFilter = '*';
var filterAtribute = 'data-filter';
var pageAtribute = 'data-page';
var pagerClass = 'isotope-pager';
var $prev = document.getElementsByClassName("pagerNavigation prev");
var $next = document.getElementsByClassName("pagerNavigation next");
var $labelPageTotal = document.getElementsByClassName("pageTotal");



$($prev).on("click", previousPage);
$($next).on("click", nextPage);

function changeFilter(selector) {
    $grid_publication.isotope({
        filter: selector
    });
}

function goToPage(n,o) {
    currentPage = n;
    lastPage = o;
    var selector = itemSelector;
    //var $thisPage= document.getElementsByClassName("pager")[currentPage-1];
    selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
    selector += '['+pageAtribute+'="'+currentPage+'"]';
    changeFilter(selector);

    //Affiche ou cache les éléments Suivant et Précendent de la pagination
    if (document.querySelector('.next')) {
        /*Si il n'y a qu'une seule page*/
        if (currentPage == 1 && currentNumberPages == 1) {
            $next[0].style.visibility = 'hidden';
            $prev[0].style.visibility = 'hidden';
            //$pagerOnePage[0].style.visibility='hidden';
        }/*Si on se retrouve à la dernière page  */
        else if (currentNumberPages == currentPage) {
            $next[0].style.visibility = "hidden";
            $prev[0].style.visibility = 'visible';
        }/*Si on se retrouve à la première page et que le nombre de page est supérieur à 1 */
        else if (currentNumberPages > 1 && currentPage == 1) {
            $prev[0].style.visibility = 'hidden';
            $next[0].style.visibility = 'visible';
        }
        else {
            $prev[0].style.visibility = 'visible';
            //$pagerOnePage[0].style.visibility='visible';
            $next[0].style.visibility = 'visible';
        }
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }


}

//function page précédente
function previousPage(){
    var newPage;
    var textNewPage;
    newPage = currentPage.valueOf()-1;
    goToPage(newPage);
    textNewPage = parseInt(newPage);
    $('.pageActuelle').val(textNewPage);

}

//fonction page suivante
function nextPage(){
    var newPage;
    var textNewPage;
    newPage = parseInt(currentPage) + 1;
    goToPage(newPage);
    textNewPage = parseInt(newPage);
    $('.pageActuelle').val(textNewPage);


}


function setPagination() {
    var itemsPerPage = 50;


    var SettingsPagesOnItems = function(e){
        var itemsLength = $grid_publication.children(itemSelector).length;
        var pages = Math.ceil(itemsLength / itemsPerPage);
        var item = 1;
        var page = 1;
        var selector = itemSelector;
        selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
        $grid_publication.children(selector).each(function(){
            if( item > itemsPerPage ) {
                page++;
                item = 1;
            }
            $(this).attr(pageAtribute, page);
            item++;
        });
        currentNumberPages = page;

    }();



    var CreatePagers = function() {
        var $isotopePager = ( $('.'+pagerClass).length == 0 ) ? $('<div class="'+pagerClass+'"></div>') : $('.'+pagerClass);
        var $totalPage = $('<div class="totalPage"></div>') ;
        $isotopePager.html('');
        $totalPage.html('');
        for( var i = 0; i < currentNumberPages; i++ ) {
            var $pager = $('<a href="javascript:void(0);" class="pager mr-1" '+pageAtribute+'="'+(i+1)+'"></a>');
            $pager.html(i+1);
            $pager.click(function(){
                var page = $(this).eq(0).attr(pageAtribute);
                var theLastPage = currentPage;
                goToPage(page,theLastPage);
                setAttribute(theLastPage);
            });

            $pager.appendTo($isotopePager);

        }

        if(document.querySelector('.pageTotal')) {

            var nbLabel = $labelPageTotal.length;
            for (i=0;i<nbLabel;i++) {
                $labelPageTotal[i].innerHTML = currentNumberPages;
            }

            //document.querySelector('.pageTotal').innerHTML = currentNumberPages;
            document.querySelector('.pageActuelle').innerHTML = currentPage;
            $('.pageActuelle').val("1");
        }

    }();
}


setPagination();
goToPage(1);


// changement de page via la boite de texte
$(document).on("keyup", ".pageActuelle", (debounce (function(){
    if($(".pagination-mobile").is(":visible")) {
        $pageSouhaitee = $('#pageMobile').val();
    }
    else if ($(".pagination-desktop").is(":visible")) {
        $pageSouhaitee = $('#pageDesktop').val();
    }
    if ($.isNumeric($pageSouhaitee)) {
        goToPage($pageSouhaitee);
    }
},400)));

